export default {
    navigation: {
        dev: 'DEV',
        referrals: 'Referrals',
        home: 'Home',
        bonus: 'Bonus',
        airDrop: 'AirDrop'
    }
};
